<script setup lang="ts">
  import { FlowResidenceWidgetQC } from '@/widgets/Flow'
</script>

<template>
  <FlowResidenceWidgetQC />
</template>
